// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/main/web/6089/js/" + chunkId + ".chunk.js"
}